import * as type from './types';

export function fetchReset(entityName) {
  return {
    type: type.FETCH_RESET,
    entityName,
  };
}
